import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { SOLD, EMPTY_TABLE, COPIED_ICON } from "src/constants/images";
import { replaceFloatValue } from "utils/replaceFloatValue";
import { formateDate } from "utils/timeFormatter";
import { WALLET } from "src/constants/routes";
import { nFormatter } from "utils/nFormatter";

//  {
//     type: { icon: SOLD.SOURCE, text: "Sold" },
//     from: "Jacobasfasfasfjasfjasfkjasjfkajsfbajksfjasjkfjkasjkf",
//     to: "Jacobasfasfasfjasfjasfkjasjfkajsfbajksfjasjkfjkasjkf",
//     price: { token: "280", value: "627.48" },
//     date: "April 29, 2021",
//   },

const tableHead = ["Type", "From", "To", "Price", " Date", "Txhash"];

const TransactionHistory = ({ data }) => {
  const icxInUSD = useSelector((state) => state.icxPricing.price);
  console.log(data);
  const copiedData = [...data];
  const [isCopied, setIsCopied] = useState(false);
  const [alert, setAlert] = useState(false);

  const history = useNavigate();

  const handleRedirection = (address) => {
    navigate(WALLET.addSlug(WALLET.INDEX, address));
  };

  const handleCopied = (item) => {
    setIsCopied(!isCopied);
    navigator.clipboard.writeText(item.hash);
    setAlert(true);
    setTimeout(() => {
      setAlert(false);
    }, 3000);
  };

  return (
    <div className="transaction-history ">
      <div className="title" style={{ color: "var(--secondary-color)" }}>
        Transaction History
      </div>
      <div className="card remove-border">
        <table class="table">
          <thead>
            <tr>
              {tableHead.map((name, index) => (
                <th key={index} scope="col">
                  {name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className={!data?.length && "empty"}>
            {data?.length ? (
              copiedData?.reverse()?.map((item, index) => (
                <tr key={index}>
                  <td className="type" scope="row">
                    <img
                      src={SOLD.SOURCE}
                      alt="sold"
                      style={{
                        filter: "var(--svg-change-color)",
                        marginTop: "-9px",
                        width: "34px",
                      }}
                      className="mb-0 me-2"
                    />
                    Sold
                  </td>
                  <td className="text-truncate">
                    <button
                      className="btn btn-link from text-decoration-none"
                      onClick={() => handleRedirection(item.from)}
                    >
                      {item.from.slice(0, 6)}...{item.from.slice(36, 42)}
                    </button>
                  </td>
                  <td className="text-truncate">
                    <button
                      className="btn btn-link to text-decoration-none"
                      onClick={() => handleRedirection(item.to)}
                    >
                      {item.to.slice(0, 6)}...
                      {item.to.slice(36, 42)}
                    </button>
                  </td>
                  <td className="price">
                    <p className="mb-1 token">{item?.price} ICX</p>
                    <p
                      className="mb-1 value"
                      style={{
                        color: "var(--profile-amount)",
                        fontSize: "13px",
                      }}
                    >
                      ($
                      {nFormatter(item?.usd_price?.toFixed(2))})
                    </p>
                  </td>
                  <td className="date-top">{formateDate(item.block_height)}</td>
                  <td
                    style={{
                      color: "var(--secondary-color)",
                      fontWeight: 400,
                      fontSize: "13px",
                    }}
                  >
                    ...{item.hash.substr(58)}
                    <span
                      className="btn p-0 ms-1 "
                      onClick={() => handleCopied(item)}
                    >
                      <img
                        src={COPIED_ICON.SOURCE}
                        alt="copied-item"
                        className="mb-1"
                      />
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <div className="no-transaction">
                <img
                  src={EMPTY_TABLE.SOURCE}
                  alt="no tranaction history"
                  className="mb-1"
                />
                <p style={{ color: "var(--light-black)" }}>
                  No Transaction(s) yet
                </p>
              </div>
            )}
          </tbody>
        </table>
      </div>
      {alert && (
        <div
          class="alert alert-primary alert-dismissible fade show px-5"
          role="alert"
        >
          Transaction Hash Copied!
        </div>
      )}
    </div>
  );
};

export default TransactionHistory;
